import {Input} from 'antd'
import styles from './Auth.module.css'
import {LGBTButton} from "../../components/lgbtButton/LGBTButton";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { auth } from '../../store/app-slice/AppSlice';
import { userLogin } from '../../models/commonModels';

export const Auth = () =>{
    const navigation = useNavigate()
    const dispatch:any = useAppDispatch();
    const [userEmail,setUserEmail] = useState("");
    const [userPass,setUserPass] = useState("")
    const sendAuthRequest=()=>{
        dispatch(auth({email:userEmail, pswd:userPass}))
    }
    const token = useAppSelector(state=>state.appStore.token)
    useEffect(()=>{
        if(token!=null&&userEmail!=""){
            const user:userLogin = {email:userEmail,pswd:userPass}
            localStorage.setItem("currentUser",JSON.stringify(user));
            navigation("*")
        }
    },[token])

    return (
        <div className={styles.auth_content}>
            <Input
                placeholder={"Ваша почта (обязательное поле)"}
                onChange={(e)=>setUserEmail(e.target.value)}
                value={userEmail} />
            <Input.Password
                placeholder={"Введите ваш пароль"}
                onChange={(e)=>setUserPass(e.target.value)}
                value={userPass} />
            <LGBTButton
                colors={["#F6503C","#E8AA18","#96C833","#318FC2","#10406E"]}
                text={"ВОЙТИ"}
                textSize={"16px"}
                onClick={()=>{sendAuthRequest()}}/>
            {/* <LGBTButton
                colors={["white"]}
                text={"Забыли пароль?"}
                textSize={"16px"}
                textColor={"black"}
                onClick={()=>{}}/> */}
                <div onClick={()=>navigation("/resetpass")} className={styles.auth_title}>Забыли пароль?</div>
            <div className={styles.auth_register} onClick={()=>navigation("/register")}>
                ЗАРЕГИСТРИРОВАТЬСЯ
            </div>
        </div>
    )
}